import qs from 'qs';
import { axiosInstance, fetchGuests, fetchLocks } from './rest';

export function getCustomTables(params) {
  const requestData = {
    params,
  };
  return axiosInstance.get(`/api/v2/customTables`, requestData);
}

export function createCustomTable(customTableDTO) {
  return axiosInstance.post(`/api/v2/customTables`, customTableDTO);
}

export function getCustomTableDetails(customTableId) {
  return axiosInstance.get(`/api/v2/customTables/${customTableId}`);
}

export function deleteCustomTable(customTableId) {
  return axiosInstance.delete(`/api/v2/customTables/${customTableId}`);
}

export function updateCustomTable(customTableId, customTableDTO) {
  return axiosInstance.put(`/api/v2/customTables/${customTableId}`, customTableDTO);
}

// Field specific endpoints
export function fetchTableFields(customTableId) {
  return axiosInstance.get(`/api/v2/customTables/${customTableId}/fields`);
}

export function createCustomTableField(customTableId, fieldDTO) {
  return axiosInstance.post(`/api/v2/customTables/${customTableId}/fields`, fieldDTO);
}

export function updateField(customTableId, fieldId, fieldDTO) {
  return axiosInstance.put(`/api/v2/customTables/${customTableId}/fields/${fieldId}`, fieldDTO);
}

export function deleteField(customTableId, fieldId) {
  return axiosInstance.delete(`/api/v2/customTables/${customTableId}/fields/${fieldId}`);
}

export function getCustomTableData(customTableId) {
  return axiosInstance.get(`/api/v2/customTables/${customTableId}/data`);
}

// Row specific endpoints
export function getCustomTableRows(customTableId, params) {
  const requestData = {
    params,
    paramsSerializer: par => qs.stringify(par, { indices: false, encode: false }),
  };
  return axiosInstance.get(`/api/v2/customTables/${customTableId}/rows`, requestData);
}

export function createCustomTableRow(customTableId, rowData) {
  return axiosInstance.post(`/api/v2/customTables/${customTableId}/rows`, rowData);
}

export function updateCustomTableRow(customTableId, rowId, rowData) {
  return axiosInstance.put(`/api/v2/customTables/${customTableId}/rows/${rowId}`, rowData);
}

export function deleteCustomTableRow(customTableId, rowId) {
  return axiosInstance.delete(`/api/v2/customTables/${customTableId}/rows/${rowId}`);
}

export function getCustomTableRowById(customTableId, rowId) {
  return axiosInstance.get(`/api/v2/customTables/${customTableId}/rows/${rowId}`);
}

export async function fetchExternalEntities(entityType, entityIds) {
  if (!entityIds || entityIds.length === 0) {
    return {};
  }

  const entityMap = {};
  
  try {
    if (entityType === 'user') {
      const response = await fetchGuests({ userIds: entityIds, roleIds: [1,5], });
      if (response && response.data && response.data.content) {
        response.data.content.forEach(user => {
          entityMap[user.id] = user;
        });
        entityIds.forEach(id => {
          if (!entityMap[id]) {
            entityMap[id] = null;
          }
        });
      }
    } else if (entityType === 'smart_lock') {
      const response = await fetchLocks({ ids: entityIds });
      if (response && response.data && response.data.content) {
        response.data.content.forEach(lock => {
          entityMap[lock.id] = lock;
        });
        entityIds.forEach(id => {
          if (!entityMap[id]) {
            entityMap[id] = null;
          }
        });
      }
    }
  } catch (error) {
    console.error(`Error fetching ${entityType} entities:`, error);
    entityIds.forEach(id => {
      entityMap[id] = null;
    });
  }

  return entityMap;
} 